"use client"

import styles from "./insurances_and_famousFrom.module.scss"
import skColors from "../../../styles/skColors"
import StyledText from "../../typography/typography-component"
import LogosCarousel, { Logo } from "../../components/LogosCarousel/LogosCarousel"
import { useTranslations } from "next-intl"

const Insurances = () => {
  const t = useTranslations("index")

  const insuranceLogos: Logo[] = [
    {
      src: "/images/insurance_logos/aok_bremen.png",
      alt: "AOK Bremen/ Bremerhaven",
      href: "",
    },
    {
      src: "/images/insurance_logos/securvita.png",
      alt: "Securvita",
      href: "",
    },
    {
      src: "/images/insurance_logos/hek.png",
      alt: "HEK",
      href: "https://www.hek.de/erstklassige-leistungen/leistungen-a-z/detail/skinuvita/",
    },
    {
      src: "/images/insurance_logos/energie_bkk.png",
      alt: "Energie BKK",
      href: "",
    },
    {
      src: "/images/insurance_logos/akzo_nobel.png",
      alt: "Akzo Nobel",
      href: "",
    },
    {
      src: "/images/insurance_logos/r+v_bkk.png",
      alt: "R+V BKK",
      href: "",
    },
    {
      src: "/images/insurance_logos/barmer.png",
      alt: "Barmer",
      href: "",
    },
    {
      src: "/images/insurance_logos/bkk_bbraun_aesculap.png",
      alt: "BKK Braun Aesculap",
      href: "https://www.bkk-bba.de/",
    },
    {
      src: "/images/insurance_logos/viactiv.png",
      alt: "Viactiv",
      href: "https://www.viactiv.de/gesundheitswissen/haut",
    },
    {
      src: "/images/insurance_logos/dak.png",
      alt: "DAK",
      href: "",
    },
  ]

  return (
    <section className={styles.insurances} id={"insurances"}>
      <StyledText color={skColors.turquoise[600]} variant={"h2"}>
        {t("insurances.title")}
      </StyledText>

      <LogosCarousel className={styles.logoCarouselInsurance} logos={insuranceLogos} />
    </section>
  )
}

export default Insurances
